export { default as Form } from 'subaccounts/components/form/SubaccountForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/form/index.js